import Axios from "./axios";

const resource = "shop-testimonials";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}